import * as React from 'react';
import { Card } from '../../Card';
import SimpleTable from '../../Common/SimpleTable/SimpleTable';
import { ILinkedExpertStatusDetails } from '../../models';
import { MappedExpertStatus } from '../../enums';

const AscParticipationTab: React.FC<IProps> = (props) => {
    const header = [
        { title: 'РЕГИОН' },
        { title: 'СПЕЦИАЛЬНОСТЬ' },
        { title: 'СТАТУС' },
    ];

    const data = props.linkedExpertStatusesDetails.map(a => ({
        id: a.ascId || a.acId,
        columns: [
            a.regionName,
            a.qualificationTitle || '-',
            MappedExpertStatus[a.status].text,
        ],
    }));

    return (
      <Card
        withoutBorder
        withoutPadding
        title={props.title || 'Участие в АПК'}
        category={props.category || 'Участие члена АК в аккредитационных подкомиссиях'}
      >
          <SimpleTable
            tableHeaders={header}
            tableRows={data}
            handleRowClick={() => true}
          />
      </Card>
    );
};

interface IProps {
    title?: string;
    category?: string;
    linkedExpertStatusesDetails: ILinkedExpertStatusDetails[];
}

export default AscParticipationTab;
